import { getLabel } from "../../hooks/use-labels";
import { getStyle } from "../../hooks/use-styles";
import HexSpinnerLoader from "../HexSpinnerLoader";
import "./style.css";

const PaymentConfirmationSpinner = () => {
  return (
    <div className="waiting-div-container">
      <HexSpinnerLoader />
      <div
        className="font-16-normal-400-lh-26 text-center"
        style={{ color: getStyle("primaryBlack") }}
      >
        {getLabel("waitingForConfirmation")}
      </div>
    </div>
  );
};

export default PaymentConfirmationSpinner;
